import { ReduxPromiseAction } from 'typedRedux/actionTypes'

export function clearNotification() {
  return {
    type: 'NOTIFICATION_CLEAR',
  }
}

export function sendNotification(
  message: string,
  style?: 'success' | 'info' | 'error' | 'warning',
  timeout?: number
): ReduxPromiseAction {
  return (dispatch) => {
    const dispatchPromise = dispatch({
      type: 'NOTIFICATION_SEND',
      meta: { style },
      payload: message,
    })

    if (timeout) {
      const timer = (<any>window).notificationTimer
      window.clearTimeout(timer)
      ;(<any>window).notificationTimer = setTimeout(
        () => dispatch(clearNotification()),
        timeout
      )
    }

    return dispatchPromise
  }
}
